<template>
  <ab-flow-base-cmp :movable="true" :block="block" class="play-sound-editor-cmp">
    <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>
    <q-card>

      <q-card-section class="bg-yellow-8 text-black">
        Play: {{soundFile}}{{loop ? ', looped' : ''}}{{backgroundPlay ? ', background' : ''}}
      </q-card-section>

    </q-card>

    <div class="results">
      <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="played"/>
      <ab-flow-link-connector v-if="!backgroundPlay" class="q-mt-sm" :block="block" type="output" event="play-progress"/>
    </div>

  </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";
import {renderMixins} from "@/components/DiagramDesigner/Editor/components/renderMixins";

export default {
  mixins: [renderMixins],
  components: { AbFlowBaseCmp, AbFlowLinkConnector},
  inject: ['canvas'],
  props: ['block'],
  name: "PlaySoundEditorCmp",
  computed: {

    /**
     * Return name
     * @return {{}}
     */
    soundFile() {
      return this.getValue(this.block.properties?.soundFile)?.title || "n/a"
    },
    /**
     * Sound channel
     * @return {{}}
     */
    soundChannel() {
      return this.block.properties?.soundChannel?.title || "n/a"
    },

    /**
     * Delay time
     * @return {{}}
     */
    loop() {
      return this.block.properties?.loop
    },

    /**
     * Background play
     * @return {{}}
     */
    backgroundPlay() {
      return this.block.properties?.backgroundPlay === 1
    },
  }
}

</script>

<style lang="scss">

.play-sound-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
